import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Armor,
  Weapon,
  StartEquipmentItem,
} from "@dndModels";

import DataUtilities from '@dndUtilities/data_utilities';

import SelectBaseItemBox from "@dndComponents/select/SelectBaseItemBox";

const data_util = DataUtilities.getInstance();

// Type Item Selector Component
interface Props {
  item: StartEquipmentItem;
  selectedItemId: string;
  onSelect: (itemId: string) => void;
}

export default function TypeItemSelector({ item, selectedItemId, onSelect }: Props) {
  let filtered = data_util.items.filter(o => o.item_type === item.item && o.max_rarity === 0);
  
  if (item.detail !== "") {
    if (item.item === "Weapon") {
      filtered = filtered.filter(o => o instanceof Weapon && o.weapon_keyword_ids.includes(item.detail));
    } else if (item.item === "Armor") {
      filtered = filtered.filter(o => o instanceof Armor && o.armor_type_id === item.detail);
    }
  }

  return (
    <Grid>
      <SelectBaseItemBox
        name={`Select a ${item.item}`}
        base_items={filtered}
        value={selectedItemId}
        item_type={item.item}
        simple_view
        onChange={onSelect}
      />
    </Grid>
  );
}
